
import { ERROR_LOGIC_MODE_CONFIG, ERROR_LOGIC_MODE_LOG } from '@utils/constants';
import { get } from 'lodash';

export function ConfigOperator() {
  // Commented the negate operators. Backend not supported yet. IF-2973
  const operator = [
    { value: 'equals', label: 'Equals' },
    //  {key: 'not equals', label: 'Not Equals'},
    { value: 'contains', label: 'Contains' },
    //  {key: 'not contains', label: 'Not Contains'}
  ];
  return operator;
}

export const getMode = mode => (mode === ERROR_LOGIC_MODE_CONFIG ? ERROR_LOGIC_MODE_LOG : ERROR_LOGIC_MODE_CONFIG);

export const getButtonText = mode => (mode === ERROR_LOGIC_MODE_CONFIG ? 'Config Logs' : 'Error Table');

export const getHeaderText = mode => (mode === ERROR_LOGIC_MODE_CONFIG ? 'Business Error Logic Configuration' : 'Configuration Logs');


